export const SET_CUSTOM_TABLE_INPUT_FIELD_DATA = "SET_CUSTOM_TABLE_INPUT_FIELD_DATA";

export function setCustomTableInputFieldDataAction(data) {
  return {
    type: SET_CUSTOM_TABLE_INPUT_FIELD_DATA,
    data: data,
  };
}
